import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Rating, useMediaQuery } from '@mui/material';
import React, { FC } from 'react';
import { CSSTransition } from 'react-transition-group';

import { CustomButton, Icon } from '../../../components';
import { IReviewsComments } from '../../../store/review/review.interface';
import { formattedDate } from '../../../utils/string/toLocaleDateString';
import Comment from '../Comment/Comment';
import CommentForm from '../Comment/CommentForm';

import styles from './ReviewItem.module.sass';
import { useReviewItem } from './useReviewItem';

interface IReviewItem {
  review: IReviewsComments;
}

const ReviewItem: FC<IReviewItem> = ({ review }) => {
  const { item, actions } = useReviewItem(review);
  const isLike = review.is_like_by_me === true ? 'blue' : 'gray';
  const isDislike = review.is_like_by_me === false ? 'blue' : 'gray';
  const mobileScreen = useMediaQuery('(min-width:540px)');
  return (
    <>
      {/*      {item.isLoading ? (
        <Skeleton
          animation="wave"
          variant="rounded"
          width="100%"
          height={160}
          style={{ marginTop: '16px' }}
        />
      ) : (*/}
      <div className={styles.list}>
        <div className={styles.review}>
          <div className={styles.top}>
            <div className={styles.left}>
              <h3 className={styles.avatar}>
                {review?.user_firstname?.slice(0, 1)}
              </h3>
              <div className={styles.info}>
                <h3 className={styles.name}>{review.user_firstname}</h3>
                <div className={styles.stars}>
                  <Rating
                    size="large"
                    readOnly
                    defaultValue={0}
                    value={Number(review.stars)}
                  />
                </div>
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.date}>
                {formattedDate(review.created_at)}
              </div>
            </div>
          </div>
          <div className={styles.text}>{review.content}</div>
          <div className={styles.bottom}>
            <div className={styles.left}>
              <CustomButton variant={isLike} onClick={actions.onSetLike}>
                <Icon variant="like" />
                {review.likes_count}
              </CustomButton>
              <CustomButton variant={isDislike} onClick={actions.onSetDislike}>
                <Icon variant="dislike" />
                {review.dislikes_count}
              </CustomButton>
            </div>
            <div className={styles.actions}>
              <div
                className={styles.answerWrapper}
                onClick={actions.onShowCommentForm}
              >
                <div className={styles.answer}>Ответить</div>
              </div>
              {item.countComments >= 1 && (
                <div className={styles.commentsWrapper}>
                  <div
                    className={styles.comments}
                    onClick={actions.onShowComments}
                  >
                    <p className={styles.text}>
                      Комментарии ({item.countComments})
                    </p>
                    {item.showComments ? (
                      <ExpandLessRoundedIcon />
                    ) : (
                      <ExpandMoreRoundedIcon />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <CSSTransition
            in={item.showCommentForm}
            classNames="comment-animation"
            timeout={300}
            unmountOnExit
          >
            <CommentForm />
          </CSSTransition>

          <CSSTransition
            in={item.showComments}
            classNames="comment-animation"
            timeout={300}
            unmountOnExit
          >
            <div className={styles.commentsContainer}>
              <Comment comments={item.comments} reviewId={review.id} />
            </div>
          </CSSTransition>
        </div>
      </div>
    </>
  );
};

export default ReviewItem;
